<template>
    <div>
        <headBox :title="title" :ti="ti" :gameid="gameid"></headBox>
    </div>
</template>

<script>
import headBox from '@/public/header/head'
export default {
  
  data () {
   return {
       title:'1',
       ti:'',
       gameid:''
   }
  },
  components:{
      headBox
  },
  mounted()
  {
      this.gameid = this.$route.query.gameID;
      this.ti = decodeURI(this.$route.query.title);
      if(this.gameid )
      {
          localStorage.printGameid = this.gameid;
          localStorage.printTi = this.ti;
      }else if(localStorage.printGameid){
          this.gameid = localStorage.printGameid;
          this.ti = decodeURI(localStorage.printTi);
      }
      
  }
}
</script>



// WEBPACK FOOTER //
// src/view/loginPrint.vue